import React, {useEffect, useState} from 'react'
import {getAllProduction, getProductionStocks} from "../../services/serviceProduction";
import {Button, Form, Modal, AutoComplete} from "antd";
import {createAllScrap} from "../../services/serviceScrap";
import ScrapStockAmountSelection from "./ScrapStockAmountSelection";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const {Option} = AutoComplete

const ScrapCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [productions, setProductions] = useState([])
    const [productionStocks, setProductionStocks] = useState([])
    const [selectedProduction, setSelectedProduction] = useState()
    const [ready, setReady] = useState(false)
    const [bulkList, setBulkList] = useState([])
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        getAllProduction()
            .then(({data}) => {
                let productionData = []
                data.forEach(item => {
                    let prodItem = {
                        text: item.productionNumber,
                        value: item.id
                    }
                    productionData.push(prodItem)
                })
                setProductions(productionData)
            })
        setReady(!ready)
    }, [])

    const handleBulkCreate = (key, value, stockId) => {
        const mockList = bulkList
        const matchedItem = mockList.find(item => item.stock.id === stockId)

        if (!matchedItem) {
            mockList.push({
                [key]: value,
                stock: {
                    id: stockId
                }
            })
            setBulkList([...mockList])
            return
        }
        matchedItem[key] = value
        setBulkList([...mockList])
    }
    const removeBulkItem = (formName, stockId) => {
        const mockList = bulkList
        const matchedItem = mockList.find(item => item.stock.id === stockId)

        if (matchedItem) {
            mockList.splice(mockList.indexOf(matchedItem), 1)
        }

        form.setFieldsValue({[formName]: ''})
        setBulkList([...mockList])
    }
    const handleProductionChange = (v, o) => {
        if (o.key) {
            getProductionStocks(o.key)
                .then(({data}) => setProductionStocks(data))
            setSelectedProduction(o.value)
        }
    }
    const handleSubmit = () => {
        enterLoadingState(setLoadings)
        const requestObj = {
            production: {
                productionNumber: selectedProduction,
            },
            stockQuantityDTOS: bulkList
        }

        createAllScrap(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Modal
                closable={false}
                style={{minWidth: '50%'}}
                open={show}
                title={'Hurda Giriş'}
                footer={[
                    <Button
                        key={'SubmitButton'}
                        type={"primary"}
                        loading={loadings[0]}
                        onClick={() => form.submit()}
                    >Kaydet</Button>,
                    <Button key={'CancelButton'} onClick={modalCloser}>Kapat</Button>
                ]}
            >
                {
                    ready ?
                        <Form
                            form={form}
                            onFinish={handleSubmit}
                            labelAlign={'left'}
                            labelCol={{span: 8}}
                            wrapperCol={{span: 16}}
                        >
                            <Form.Item
                                name={'production'}
                                label={'Üretim'}
                                rules={[
                                    {required: true, message: 'Üretim Numarası Alanı Boş Bırakılamaz'}
                                ]}
                            >
                                <AutoComplete
                                    style={{minWidth: '75px'}}
                                    onChange={handleProductionChange}
                                >
                                    {
                                        productions.map(({value, text}) => {
                                            return <Option key={value} value={text}>{text}</Option>
                                        })
                                    }
                                </AutoComplete>
                            </Form.Item>
                            {
                                productionStocks.length ?
                                    <React.Fragment>
                                        {
                                            productionStocks.map((item, index) => {
                                                return (
                                                    <ScrapStockAmountSelection
                                                        key={index}
                                                        index={index}
                                                        remover={removeBulkItem}
                                                        stockLabel={`${item.code} - ${item.name}`}
                                                        stockId={item.id}
                                                        handler={handleBulkCreate}
                                                    />
                                                )
                                            })
                                        }
                                    </React.Fragment>
                                    : null
                            }
                        </Form>
                        : <span>Yükleniyor..</span>
                }

            </Modal>
        </React.Fragment>
    )
}
export default ScrapCreate